import { render, staticRenderFns } from "./OrderFlag.vue?vue&type=template&id=6877a3f0&"
import script from "./OrderFlag.vue?vue&type=script&lang=js&"
export * from "./OrderFlag.vue?vue&type=script&lang=js&"
import style0 from "./OrderFlag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports